<template>
  <!--切片上传-->
  <div class="upload-wrap">
    <el-upload
      ref="videoUpload"
      :auto-upload="uploadConfig.autoUpload"
      :action="uploadConfig.uploadVideoUrl"
      :on-success="handleVideoSuccess"
      :on-progress="uploadVideoProcess"
      :on-remove="handleRemove"
      :before-upload="beforeVideoUpload"
      :on-change="videoChange"
      :disabled="videoDisabled || !uploadOver"
      :accept="uploadConfig.accept || '.mp4'"
      :on-error="errorUpload"
      :on-exceed="handleExceed"
      :show-file-list="uploadConfig.showFileList"
      :limit="uploadConfig.limit"
      :file-list="fileList"
    >
      <!-- <i class="el-icon-plus avatar-uploader-icon"></i> -->
      <el-button type="text">{{ btnName }}</el-button>
    </el-upload>

    <!-- <div class="readyUpload" v-if="openSectionUpload && isReady">
      <div class="progress-box">
        <el-progress :percentage="Math.floor(percent)"></el-progress>
      </div>
      <el-button type="primary" :disabled="disBol" @click="subbits"
        >开始</el-button
      >
      <el-button type="primary" @click="handleClickBtn">{{
        upload | btnTextFilter
      }}</el-button>
      <el-button type="danger" @click="removeFile">移除</el-button>
    </div>
    <ul
      class="video-wrap"
      v-if="fileList.length > 0 && uploadConfig.showPreview"
    >
      <li class="imageItem" v-for="(item, index) in fileList" :key="index">
        <div>
          <video-box :videoConfig="videoConfig"></video-box>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.fileName"
            placement="top-start"
          >
            <span class="videoName">{{ showFileName(item) }}</span>
          </el-tooltip>
        </div>
      </li>
    </ul> -->
  </div>
</template>
<script>
// import { sevUrl } from '@/utils/utils.js'
import videoBox from '@/components/video/video.vue'
import ckPlayer from '@/components/video/ckplayer.vue'
import SparkMD5 from "spark-md5"
import axios from "axios"
import api from '@/utils/requst.js'
export default {
  name: 'upload',
  components: { videoBox, ckPlayer },
  props: {
    uploadConfig: {
      type: Object,
      default: () => {
        return {}
      }
    },

    btnName: {
      type: String,
      default: () => {
        return '上传文件'
      }
    },
  },
  filters: {
    btnTextFilter(val) {
      return val ? '暂停' : '继续'
    }
  },
  data() {
    return {
      progressFlag: false,
      videoDisabled: false,
      fileList: [],//视频文件
      //大文件上传所需参数
      percent: 0,
      videoUrl: '',
      upload: true,
      percentCount: 0,
      timestamp: '',
      fileName: '',
      disBol: false,
      requestList: [],
      openSectionUpload: true,//是否开启切片上传模式
      cutType: '1',//切片方式，1：按文件大小切，2：按时长切(目前只有1)
      sizeLimit: 30 * 1024 * 1024,//按文件大小切片粒度，单位B（这里设定为1M）
      timeLimit: 20,//按时长切片粒度,单位：秒
      // maxFileSize: 50,//大于50M的视频采用分片上传
      uploadOver: true,//大文件是否上传完毕
      isReady: false,//选择文件后等待上传
      fileMd5: '',//当前上传文件的Md5
      chunkList: [],//切片队列
      chunkNum: 0,//上传文件的切片数

      //视频播放缩略图配置
      videoConfig: {
        width: '80px',
        height: '80px',
        autoplay: false,
        loop: true,
        muted: 'muted',
        controls: true,
        controlslist: ''
      }
    }
  },
  watch: {
    uploadConfig: {
      handler(newVal, oldVal) {
        this.fileList = [...this.uploadConfig.fileList]
      },
      deep: true
    }
  },
  mounted() {
    this.fileList = [...this.uploadConfig.fileList]
  },
  methods: {
    //进度条
    uploadVideoProcess(event, file, fileList) {
      // this.videoDisabled = true
      // this.progressFlag = true; // 显示进度条
      // this.loadProgress = parseInt(event.percent); // 动态获取文件上传进度
      // if (this.loadProgress >= 100) {
      //   this.loadProgress = 100
      //   setTimeout(() => { this.progressFlag = false }, 1000) // 一秒后关闭进度条
      // }
    },
    errorUpload() {
      this.videoDisabled = false
    },
    // 视频上传验证视频类型
    beforeVideoUpload(video) {
      let index = video.name.lastIndexOf(".");
      let videoExtensions = video.name.substring(index, video.name.length);
      if (!['.mp4', '.MP4'].includes(videoExtensions)) {
        this.$message.warning('请上传mp4格式的视频')
        return false
      }
      // 限制上传 300M
      const max3 = video.size / 1024 / 1024 <= 300;
      if (!max3) {
        this.$message.warning('请上传文件大小不超过300MB的视频')
        return false
      }
    },
    // 删除单个视频
    handleRemove(file, fileList, e = undefined) {
      if (this.fileList.includes(file)) {
        let index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        this.$message.success('删除课程视频成功')
        if (e) e.stopPropagation() // 阻止冒泡 触发视频上传
        this.videoDisabled = false
      }
    },
    //视频上传成功（自动上传）
    handleVideoSuccess(res, file) {
      if (res.code == 200) {
        this.$message.success('课程视频上传成功');
        let duration = parseInt(res.data.seconds)
        let hours = Number(duration / (45 * 60))
        res.data.hours = this.calculateHour(hours)
        res.data.videoDuration = duration
        res.data.url = res.data.fileUrl
        res.data.name = res.data.fileName
        this.fileList.push(res.data);
        // console.log('文件列表', this.fileList);
        this.videoDisabled = false
      } else {
        this.$message.error('课程上传失败:' + res.message);
        this.videoDisabled = false
      }
    },
    calculateHour(hours) {
      if (hours <= 1) return 1
      let initHours = parseInt(hours)
      let floatNum = hours - initHours
      if (floatNum <= 0.5) {
        return initHours + 0.5
      } else {
        return initHours + 1
      }
    },
    showFileName(item) {
      return item.fileName
        ? item.fileName.substring(0, 5) + '...'
        : item.name.substring(0, 5) + '...'
    },
    handleExceed(files, fileList) {
      this.$message.warning(`只能上传1个视频`);
    },
    //===============大文件上传
    async videoChange(file, fileList) {
      if (!file) return
      //校验文件类型
      let index = file.name.lastIndexOf(".");
      let videoExtensions = file.name.substring(index, file.name.length);
      if (!['.mp4', '.MP4'].includes(videoExtensions)) {
        this.$message.warning('请上传mp4格式的视频')
        fileList.pop()
        return false
      }
      this.$emit('startUpload')
      if (this.openSectionUpload) {
        if (this.cutType == '1') { //按文件大小切片
          this.isReady = true
          this.uploadOver = false
          this.timestamp = new Date().getTime()
          this.percent = 0
          this.videoUrl = ''
          const fileObj = file.raw
          // 获取文件并转成 ArrayBuffer 对象（ArrayBuffer：二进制数据对象）
          let buffer
          try {
            buffer = await this.fileToBuffer(fileObj) //将file对象转化为buffer对象
          } catch (e) {
            console.log(e)
          }
          this.fileName = fileObj.name
          //获取文件的md5值
          var Spark = new SparkMD5.ArrayBuffer()
          Spark.append(buffer)
          this.fileMd5 = Spark.end()
          // 将文件按固定大小进行切片，注意此处同时声明了多个常量
          const chunkSize = this.sizeLimit,//单位B
            chunkList = [], // 保存所有切片的数组
            chunkListLength = Math.ceil(fileObj.size / chunkSize), // 计算总共多个切片
            suffix = /\.([0-9A-z]+)$/.exec(fileObj.name)[1], // 文件后缀名
            fileName = fileObj.name, // 文件名
            prefix = this.fileName.substring(0, this.fileName.lastIndexOf("."))//纯文件名（不包含后缀）
          // 生成切片，这里后端要求传递的参数为字节数据块（chunk）和每个数据块的文件名（fileName）
          let curChunk = 0 // 切片时的初始位置
          for (let i = 0; i < chunkListLength; i++) {
            const item = {
              id: this.fileMd5,//id为文件的md5值
              chunk: fileObj.slice(curChunk, curChunk + chunkSize),
              fileName: `${prefix}_${i}.${suffix}` // 文件名规则按照 hash_1.jpg 命名
            }
            curChunk += chunkSize
            chunkList.push(item)
          }
          this.chunkList = chunkList // sendRequest 要用到
          this.chunkNum = chunkList.length
          this.sendRequest()
        } else {//按时长切片（待实现）
          // this.uploadOver = false
          //获取视频的时长
          // let url = window.URL.createObjectURL(file.raw);
          // let audioElement = new Audio(url)
          // let duration
          // audioElement.addEventListener('loadedmetadata', function (_event) {
          //   duration = audioElement.duration //时长为秒，小数，182.36
          //   // this.$parent.$data.wDuration = parseInt(duration)
          //   // item.duration = parseInt(duration)
          //   console.log(duration)
          // })
        }
      } else {//不开启切片上传
        this.isReady = false
        this.$refs.videoUpload.submit();//执行上传
      }
    },
    // 发送请求
    sendRequest() {
      this.requestList = [] // 请求集合
      this.chunkList.forEach((item, index) => {
        const fn = () => {
          const formData = new FormData()
          formData.append('file', item.chunk)
          formData.append('id', item.id)
          formData.append('fileName', item.fileName)
          return axios({
            url: this.uploadConfig.uploadVideoUrl,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data' },
            data: formData
          }).then(res => {
            this.percentCount = 100 / this.chunkNum
            this.percent += this.percentCount // 改变进度
            this.chunkList.splice(index, 1) // 一旦上传成功就删除这一个 chunk，方便断点续传
          })
        }
        this.requestList.push(fn)
      })

      let i = 0 // 记录发送的请求个数
      // 文件切片全部发送完毕后，需要请求 '/merge' 接口，把文件的 hash 传递给服务器
      const complete = () => {
        api.post2(this.uploadConfig.mergeUrl, {
          fileName: this.fileName,
          id: this.fileMd5
        }).then(res => {
          this.resetFields()
          //上传成功后添加到文件对列
          let duration = parseInt(Number(res.seconds))
          let hours = Number(duration / (45 * 60))
          this.fileList.push({
            ...res,
            hours: this.calculateHour(hours),
            videoDuration: duration,
            url: res.fileUrl,
            path: res.filePath,
            type: res.fileType,
            name: res.fileName
          })
          this.$emit('uploadSuccess', res)
        }).finally(() => {
          this.$emit('endUpload')
        })
      }
      const send = async () => {
        if (!this.upload) return
        if (i >= this.requestList.length) {
          // 发送完毕
          complete()
          return
        }
        await this.requestList[i]()
        i++
        send()
      }
      send() // 发送请求
    },
    // 按下暂停按钮
    handleClickBtn() {
      this.upload = !this.upload
      // 如果不暂停则继续上传
      if (this.upload) this.sendRequest()
    },
    // 将 File 对象转为 ArrayBuffer 
    fileToBuffer(file) {
      return new Promise((resolve, reject) => {
        const fr = new FileReader()
        fr.onload = e => {
          resolve(e.target.result)
        }
        fr.readAsArrayBuffer(file)
        fr.onerror = () => {
          reject(new Error('转换文件格式发生错误'))
        }
      })
    },
    subbits() {
      this.disBol = true
      this.sendRequest()
      // this.$refs.upload.submit();
    },
    removeFile() {
      this.upload = false
      this.$confirm(`确认移除当前视频吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs.videoUpload.uploadFiles.pop()
        this.resetFields()
      }).catch(() => {
        this.upload = true
        this.sendRequest()
      })
    },
    //上传成功后重置数据
    resetFields() {
      this.fileName = ''
      this.fileMd5 = ''
      this.isReady = false
      this.uploadOver = true
      this.percent = 0
      this.disBol = false
      this.upload = true
      this.chunkNum = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-wrap {
  margin: 0px 10px;
  /deep/ .avatar-uploader .el-upload {
    position: relative;
    width: 80px;
    height: 80px;
    background: #3a455e;
    border: 0.67px dashed #c0ccda;
    border-radius: 2.67px;
    .avatar {
      width: 100%;
      height: 100%;
    }
    .avatar-uploader-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .video-wrap {
    display: flex;
    margin-top: 12px;
    .imageItem {
      display: inline-block;
      margin-right: 10px;

      > div {
        position: relative;
        width: 80px;
        display: flex;
        flex-direction: column;

        video,
        .file_icon_box {
          width: 80px;
          height: 80px;
        }
        .file_icon_box {
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #f0f0f0;
        }
        .videoName {
          white-space: nowrap;
          margin-top: 10px;
        }
        .imgDel {
          display: none;
          position: absolute;
          text-align: center;
          top: 0px;
          width: 100%;
          height: 80px;
          background: rgba(0, 0, 0, 0.8);

          i {
            line-height: 80px;
            cursor: pointer;
          }
        }

        span {
          display: block;
          width: 100%;
          line-height: 14px;
          white-space: normal;
          word-break: keep-all;
          word-wrap: break-word;
        }
      }

      > div:hover {
        .imgDel {
          display: block;
          cursor: default;
        }
      }
    }
  }
  .readyUpload {
    background-color: #f3f5fa;
    padding: 5px 10px;
    margin-top: 10px;
    // .progress-box {
    //   box-sizing: border-box;
    //   width: 100%;
    //   display: flex;
    //   justify-content: space-between;
    //   align-items: center;
    //   margin-top: 10px;
    //   padding: 8px 10px;
    //   background-color: #ccc;
    //   font-size: 14px;
    //   border-radius: 4px;
    // }
    /deep/ .el-progress-bar__outer {
      background-color: #ccc;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/video/upload.vue